import styled from 'styled-components/macro'
import { Form } from 'formik'

export const FormikFormStyled = styled(Form)`
  width: 100%;
  margin-bottom: 24px;
`
